import React from 'react'
import './loader.css'

const Loader = () => {
  return (
    <div className='load'></div>
  )
}

export default Loader